import { ref, watch } from "vue";
import { getRefs } from "../utils";

interface MultiRangeSliderProps {
  rootEl: HTMLElement;
  min?: number;
  max?: number;
  minDistance?: number;
  suffix?: string;
  onChange?: (min: number, max: number) => void;
}

export const MultiRangeSlider = (props: MultiRangeSliderProps) => {
  const { min = 0, max = 100, minDistance = 0 } = props;

  const minVal = ref(min);
  const maxVal = ref(max);

  const refs = getRefs<{
    minThumb: HTMLElement;
    maxThumb: HTMLElement;
    track: HTMLElement;
    minSlider: HTMLInputElement;
    maxSlider: HTMLInputElement;
    minValue: HTMLElement;
    maxValue: HTMLElement;
  }>(props.rootEl);

  refs.minSlider.min = min.toString();
  refs.minSlider.max = max.toString();
  refs.minSlider.value = min.toString();
  refs.maxSlider.min = min.toString();
  refs.maxSlider.max = max.toString();
  refs.maxSlider.value = max.toString();

  refs.minSlider.addEventListener("input", (e) => {
    const value = (e.target as HTMLInputElement).valueAsNumber;
    minVal.value = Math.min(value, maxVal.value - minDistance);
    props.onChange?.(minVal.value, maxVal.value);
  });
  refs.minSlider.addEventListener("mouseup", (e) => {
    refs.minSlider.value = minVal.value.toString();
  });

  refs.maxSlider.addEventListener("input", (e) => {
    const value = (e.target as HTMLInputElement).valueAsNumber;
    maxVal.value = Math.max(value, minVal.value + minDistance);
    props.onChange?.(minVal.value, maxVal.value);
  });
  refs.maxSlider.addEventListener("mouseup", (e) => {
    refs.maxSlider.value = maxVal.value.toString();
  });

  watch(
    [minVal, maxVal],
    ([clampedMin, clampedMax]) => {
      const suffix = props.suffix ? ` ${props.suffix}` : "";
      refs.minValue.innerText = clampedMin.toString() + suffix;
      refs.maxValue.innerText = clampedMax.toString() + suffix;

      const minPercent = (clampedMin - min) / (max - min);
      const maxPercent = (clampedMax - min) / (max - min);

      refs.minThumb.style.left = `calc(${minPercent * 100}% -  ${minPercent} * 1rem)`;
      refs.maxThumb.style.left = `calc(${maxPercent * 100}% -  ${maxPercent} * 1rem)`;

      refs.track.style.left = `${minPercent * 100}%`;
      refs.track.style.right = `${100 - maxPercent * 100}%`;
    },
    { immediate: true, deep: true }
  );
};
